import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.PirateChestPositions.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.PirateChestPositions.GameData;
  this.iteration = 0;
  this.chest = [];
  this.choices = [];
  this.answers = ['inside', 'above', 'under', 'next-to'];
};

EDC.Games.PirateChestPositions.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.PirateChestPositions.Scenes.Main.prototype.constructor = EDC.Games.PirateChestPositions.Scenes.Main;

const PCP = EDC.Games.PirateChestPositions.Scenes.Main.prototype;

PCP.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

PCP.createTemplateUI = function () {
  this.add.sprite(350, 150, 'title');
  this.add.sprite(1400, 665, 'board-choices');
  this.add.sprite(1400, 130, 'board-instructions');
  this.add.sprite(1400, 195, 'instructions');
};

PCP.loadIteration = function () {
  const answer = this.answers[this.iteration % 4];
  let chest;
  let treasure;
  if (answer === 'inside') {
    chest = this.add.sprite(560, 466, 'chest-treasure');
    this.scaleTreasure(chest);
    this.chest.push(chest);
  } else if (answer === 'above') {
    chest = this.add.sprite(585, 795, 'chest-empty');
    treasure = this.add.sprite(580, 550, 'treasure');
    this.scaleTreasure(chest, treasure);
    this.chest.push(chest);
    this.chest.push(treasure);
  } else if (answer === 'under') {
    chest = this.add.sprite(560, 460, 'chest-empty');
    treasure = this.add.sprite(560, 870, 'treasure');
    this.scaleTreasure(chest, treasure);
    this.chest.push(chest);
    this.chest.push(treasure);
  } else if (answer === 'next-to') {
    chest = this.add.sprite(560, 460, 'chest-empty');
    treasure = this.add.sprite(850, 545, 'treasure');
    this.scaleTreasure(chest, treasure);
    this.chest.push(chest);
    this.chest.push(treasure);
  }
  this.createChoices(answer);
};

PCP.scaleTreasure = function (sprite1, sprite2, delay) {
  let randomDelay = delay;
  if (!delay) {
    randomDelay = 300;
  }
  sprite1.scaleAnim = this.tweens.add({
    targets: sprite1,
    scaleX: 1.3,
    scaleY: 1.3,
    duration: 400,
    ease: 'Sine.easeInOut',
    delay: randomDelay,
    yoyo: true,
    onComplete: this.scaleTreasure.bind(
      this,
      sprite1,
      sprite2,
      5000 + Math.floor(Math.random() * 3000),
    ),
  });
  if (sprite2) {
    this.tweens.add({
      targets: sprite2,
      scaleX: 1.3,
      scaleY: 1.3,
      duration: 400,
      ease: 'Sine.easeInOut',
      delay: randomDelay - 1,
      yoyo: true,
    });
  }
};

PCP.createChoices = function (answer) {
  const choices = {
    0: 'inside',
    1: 'next-to',
    2: 'above',
    3: 'under',
  };
  for (let i = 0; i < 4; i++) {
    const container = this.add.container(1400, 440 + i * 180);
    const sprite = this.add.sprite(0, 0, choices[i]);
    container.add(sprite);
    if (choices[i] === answer) {
      container.isCorrect = true;
    } else {
      container.isCorrect = false;
    }
    container.setSize(sprite.displayWidth, sprite.displayHeight);
    this.shakeAnimation(container);
    container.setInteractive();
    const markAnim = new AnswerMark(this, container).setScale(0.25);
    container.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(container);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.choices.push(container);
  }
};

PCP.checkAnswer = function (choice) {
  if (choice.isCorrect) {
    this.playCorrect();
    this.choices.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
    });
    choice.getData('markAnim').showMark(true, () => {});
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    choice.first.setTint(0xff0000);
    choice.shakeAnim.stop();
    choice.angle = 0;
    choice.disableInteractive();
    this.playWrong();
    choice.getData('markAnim').showMark(false, () => {});
  }
};

PCP.nextIteration = function () {
  this.choices.map((x) => {
    x.destroy();
  });
  this.choices = [];
  this.chest.map((x) => {
    x.destroy();
    if (x.scaleAnim) {
      x.scaleAnim.stop();
    }
  });
  this.chest = [];
  this.iteration = this.iteration + 1;
  const { iterations } = this.gameConfig.sets[0];
  if (this.iteration >= iterations) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

PCP.shakeAnimation = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: 1,
    duration: 100,
    ease: 'Linear',
    repeat: 6,
    delay: 5000,
    yoyo: true,
    onActive: this.adjustAngle.bind(this, choice),
    onComplete: this.shakeAnimation.bind(this, choice),
  });
};

PCP.adjustAngle = function (choice) {
  choice.angle = -1;
};

export default EDC.Games.PirateChestPositions.Scenes.Main;
